var map = {
	"./data/exchange-rates": 2533,
	"./data/exchange-rates.json": 2533,
	"./fonts/Digital_numbers/DigitalNumbers-Regular.ttf": 9505,
	"./fonts/Exo_2/Exo2-Italic-VariableFont_wght.ttf": 8932,
	"./fonts/Exo_2/Exo2-VariableFont_wght.ttf": 4853,
	"./fonts/Exo_2/static/Exo2-Black.ttf": 893,
	"./fonts/Exo_2/static/Exo2-BlackItalic.ttf": 7289,
	"./fonts/Exo_2/static/Exo2-Bold.ttf": 6597,
	"./fonts/Exo_2/static/Exo2-BoldItalic.ttf": 5809,
	"./fonts/Exo_2/static/Exo2-ExtraBold.ttf": 6183,
	"./fonts/Exo_2/static/Exo2-ExtraBoldItalic.ttf": 6687,
	"./fonts/Exo_2/static/Exo2-ExtraLight.ttf": 174,
	"./fonts/Exo_2/static/Exo2-ExtraLightItalic.ttf": 9498,
	"./fonts/Exo_2/static/Exo2-Italic.ttf": 8272,
	"./fonts/Exo_2/static/Exo2-Light.ttf": 6300,
	"./fonts/Exo_2/static/Exo2-LightItalic.ttf": 4780,
	"./fonts/Exo_2/static/Exo2-Medium.ttf": 393,
	"./fonts/Exo_2/static/Exo2-MediumItalic.ttf": 3557,
	"./fonts/Exo_2/static/Exo2-Regular.ttf": 7340,
	"./fonts/Exo_2/static/Exo2-SemiBold.ttf": 3935,
	"./fonts/Exo_2/static/Exo2-SemiBoldItalic.ttf": 5559,
	"./fonts/Exo_2/static/Exo2-Thin.ttf": 2701,
	"./fonts/Exo_2/static/Exo2-ThinItalic.ttf": 2921,
	"./fonts/Inter/Inter-VariableFont_slnt,wght.ttf": 4241,
	"./fonts/Inter/static/Inter-Black.ttf": 4300,
	"./fonts/Inter/static/Inter-Bold.ttf": 3906,
	"./fonts/Inter/static/Inter-ExtraBold.ttf": 286,
	"./fonts/Inter/static/Inter-ExtraLight.ttf": 9077,
	"./fonts/Inter/static/Inter-Light.ttf": 4113,
	"./fonts/Inter/static/Inter-Medium.ttf": 498,
	"./fonts/Inter/static/Inter-Regular.ttf": 2353,
	"./fonts/Inter/static/Inter-SemiBold.ttf": 9172,
	"./fonts/Inter/static/Inter-Thin.ttf": 2158,
	"./fonts/Square_peg/SquarePeg-Regular.ttf": 251,
	"./icons/affichage-icon.svg": 2537,
	"./icons/arabic.svg": 527,
	"./icons/archive-clock-icon.svg": 5552,
	"./icons/archive-office-icon.svg": 3150,
	"./icons/arrow-button-icon.svg": 1199,
	"./icons/assistance-icon.svg": 531,
	"./icons/biat-arrow.svg": 1115,
	"./icons/biat-dark-arrow.svg": 3216,
	"./icons/billing-machine-icon.svg": 5654,
	"./icons/calendar-grey-icon.svg": 9675,
	"./icons/calendar-icon.svg": 5357,
	"./icons/call-icon.svg": 83,
	"./icons/cancel-red-icon.svg": 1083,
	"./icons/clear-button-icon.svg": 6611,
	"./icons/confirm-icon.svg": 3205,
	"./icons/controlls-icon.svg": 4101,
	"./icons/delete-button-icon.svg": 9043,
	"./icons/delete-red-icon.svg": 706,
	"./icons/eject-button-icon.svg": 2871,
	"./icons/email-icon.svg": 8917,
	"./icons/english.svg": 733,
	"./icons/error-icon.svg": 8867,
	"./icons/file-attente-icon.svg": 1424,
	"./icons/folder-icon.svg": 591,
	"./icons/french.svg": 2579,
	"./icons/historique-icon.svg": 9430,
	"./icons/hourglass-button-icon.svg": 738,
	"./icons/info-icon.svg": 6999,
	"./icons/language-icon.svg": 7113,
	"./icons/left-arrow-white.svg": 9576,
	"./icons/login-icon.svg": 7308,
	"./icons/menu-button-icon.svg": 3347,
	"./icons/minutes-icon.svg": 1264,
	"./icons/next-button-icon.svg": 4861,
	"./icons/paginator-left-arrow.svg": 842,
	"./icons/paginator-right-arrow.svg": 6665,
	"./icons/password-icon.svg": 2478,
	"./icons/radio-button-grey-icon.svg": 2207,
	"./icons/radio-button-white-icon.svg": 7557,
	"./icons/remove-button-icon.svg": 6338,
	"./icons/request-callback-icon.svg": 2392,
	"./icons/right-arrow-white.svg": 4631,
	"./icons/rotate.svg": 8338,
	"./icons/settings-icon.svg": 3790,
	"./icons/stopwatch-icon.svg": 3518,
	"./icons/tick-mark-icon.svg": 8544,
	"./icons/ticket-icon.svg": 6743,
	"./icons/volume-up-button-icon.svg": 1132,
	"./icons/waiting-queue-icon.svg": 2632,
	"./icons/web-browser-icon.svg": 7314,
	"./images/Logo_Bleu.png": 8183,
	"./images/avatar.png": 5536,
	"./images/biat-bg.png": 9523,
	"./images/biat-logo.png": 1163,
	"./images/display-image.png": 7209,
	"./images/flags/aed.svg": 703,
	"./images/flags/bh.svg": 9117,
	"./images/flags/ca.svg": 1099,
	"./images/flags/ch.svg": 3474,
	"./images/flags/cny.svg": 9549,
	"./images/flags/eu.svg": 2629,
	"./images/flags/gb.svg": 8260,
	"./images/flags/jpy.svg": 5326,
	"./images/flags/kw.svg": 9485,
	"./images/flags/lyd.svg": 3386,
	"./images/flags/qa.svg": 8157,
	"./images/flags/sa.svg": 3643,
	"./images/flags/se.svg": 503,
	"./images/flags/us.svg": 891,
	"./images/logo_white.png": 7852,
	"./images/no-ticket-data.png": 876,
	"./images/placeholder.jpg": 7472,
	"./images/placeholder_video.png": 3591,
	"./images/statistics-image.png": 4670,
	"./images/video-editing.png": 2965,
	"./images/weather/cloudy.png": 5480,
	"./images/weather/ice.png": 8199,
	"./images/weather/overcast.png": 5511,
	"./images/weather/partly_cloudy.png": 2547,
	"./images/weather/rainy.png": 45,
	"./images/weather/snowy.png": 7524,
	"./images/weather/sunny.png": 8179,
	"./images/weather/thunder.png": 7492,
	"./images/weather/thunder_storm.png": 6910,
	"./images/weather/windy.png": 425,
	"./sounds/airport.mp3": 7303,
	"./sounds/notification.mp3": 6679,
	"./sounds/slow-spring-board.mp3": 4994,
	"./video/BIAT-display.webm": 5443,
	"./video/UBCI_video.mp4": 5321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;